import * as React from 'react';
import { Button, Form, Input, Modal, Table, message } from 'antd';
import { EventSubscription } from 'fbemitter';

import AdminDispatcher from '../../dispatchers/AdminDispatcher';
import AdminStore from '../../stores/AdminStore';
import { addAdmin, removeAdmin } from '../../PoolAPI';
import { removeListener } from '../../utils';

interface AdminTabData {
  newAdminEmail: string;

  emails: string[];
}

export class AdminTab extends React.Component<{}, AdminTabData> {
  private adminListener: EventSubscription | null = null;

  constructor(props: {}) {
    super(props);

    this.state = {
      newAdminEmail: '',
      emails: AdminStore.getAdmins(),
    };
  }

  render() {
    const adminData = this.state.emails.map((e: string) => {
      return { email: e };
    });
    return (
      <span>
        <h2>Existing Admins</h2>
        <Table
          dataSource={adminData}
          rowKey="email"
          size="small"
          pagination={false}
          columns={[
            {
              title: 'Email',
              dataIndex: 'email',
              key: 'email',
            },
            {
              title: 'Action',
              key: 'action',
              render: (text, record) => (
                <span>
                  <a onClick={() => this.deleteAdmin(record.email)}>Delete</a>
                </span>
              ),
            },
          ]}
        />
        <br />
        <h2>Add new admins:</h2>
        <Form layout="inline">
          <Form.Item label="Email">
            <Input
              value={this.state.newAdminEmail}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                this.setState({
                  newAdminEmail: e.target.value,
                });
              }}
            />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                e.currentTarget.blur();
                this.addAdmin(this.state.newAdminEmail);
              }}
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </span>
    );
  }

  componentDidMount() {
    this.adminListener = AdminStore.addListener(() => {
      this.setState({
        emails: AdminStore.getAdmins(),
      });
    });
  }

  componentWillUnmount() {
    removeListener(this.adminListener);
  }

  private async addAdmin(email: string) {
    const r = await addAdmin(email);
    if (r.status === 200) {
      const j = await r.json();
      AdminDispatcher.handleUpdateAdmins(j);
      this.setState({ newAdminEmail: '' });
    } else {
      message.error('Failed to add new admin.');
    }
  }

  private deleteAdmin(email: string) {
    Modal.confirm({
      title: 'Are you sure you want to remove this admin?',
      content: email + ' will no longer have access to the admin panel.',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk: async () => {
        const r = await removeAdmin(email);
        if (r.status === 200) {
          const j = await r.json();
          AdminDispatcher.handleUpdateAdmins(j);
        } else {
          message.error('Failed to remove admin.');
        }
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/AdminTabs/AdminTab.tsx